import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';

import { SpConnectBuilderAddressInterface } from '../interfaces/sp-connect-builder-address.interface';

export class SpConnectBuilderAddressDto
  implements SpConnectBuilderAddressInterface
{
  @ApiProperty()
  @IsOptional()
  name?: string;
}
